import { Extension } from '@tiptap/core';

export const OriginalState = Extension.create({
   name: 'originalState',

   onCreate() {
      this.storage.savedContent = this.editor.state.doc;
   },

   addStorage() {
      return {
         savedContent: null,
      };
   },
});
